import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';

import { Button } from '@comparethemarketau/manor-button';

import { getBreakpointFromManor } from 'ctm-components';
import { removeDispatchMapping } from './compare_store_mapping';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginBottom: '0.8rem',
        width: '100%'
    },
    button: {
        margin: 0,
        padding: 0,
        width: '100%',
        fontWeight: theme.fontWeight.normal,
        fontSize: ({ breakpoint }) => {
            if (breakpoint === 'xs') {
                return theme.fontSize.xs;
            }
            return theme.fontSize.sm;
        },
        lineHeight: '1.6rem',
        color: theme.colors.grey600,
        '&:hover': {
            background: 'unset'
        }
    }
}));

const _RemoveButton = (props) => {
    const { removeProduct, productId } = props;
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });

    const handleClick = (event) => {
        event.preventDefault();
        if (productId) {
            removeProduct(productId);
        }
    };

    return (
        <div className={classes.container}>
            <Button
                trackingLabel={`Remove the comparing product ${productId}`}
                variant="tertiary"
                icon={faTrashAlt}
                handleClick={handleClick}
                className={classes.button}
            >
                Remove
            </Button>
        </div>
    );
};

_RemoveButton.propTypes = {
    removeProduct: PropTypes.func,
    productId: PropTypes.string.isRequired
};

const RemoveButton = connect(null, removeDispatchMapping)(_RemoveButton);

export { RemoveButton };
